import React, { useState } from 'react'
import { authProvider } from '../authProvider'

interface ForgotPasswordPageProps {
  onBack: () => void
}

export const ForgotPasswordPage: React.FC<ForgotPasswordPageProps> = ({ onBack }) => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    console.log('🔍 Attempting password reset for:', email)

    setLoading(true)
    setError('')

    try {
      await authProvider.resetPassword(email)
      setSuccess(true)
      console.log('✅ Password reset email sent')
    } catch (err: any) {
      console.error('❌ Password reset error:', err)
      setError(err.message || 'Błąd podczas resetowania hasła')
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          width: '100%',
          maxWidth: '400px',
          textAlign: 'center'
        }}>
          <div style={{ marginBottom: '2rem' }}>
            <img
              src="/assets/logo.svg"
              alt="TwoPoint"
              style={{ height: '32px' }}
            />
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#4CAF50', marginBottom: '1rem' }}>✅ Email wysłany!</h2>
            <p style={{ color: '#666', margin: 0 }}>
              Sprawdź swoją skrzynkę pocztową.<br />
              Otrzymasz link do zresetowania hasła na adres:<br />
              <strong>{email}</strong>
            </p>
          </div>

          <button
            onClick={onBack}
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor: '#000000',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1rem',
              cursor: 'pointer'
            }}
          >
            Powrót do logowania
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img
            src="/assets/logo.svg"
            alt="TwoPoint"
            style={{ height: '32px' }}
          />
        </div>

        <h2 style={{ textAlign: 'center', marginBottom: '1rem' }}>
          Resetuj hasło
        </h2>

        <p style={{ textAlign: 'center', color: '#666', marginBottom: '2rem' }}>
          Podaj adres email, a wyślemy Ci link do zresetowania hasła
        </p>

        {error && (
          <div style={{
            backgroundColor: '#ffebee',
            color: '#c62828',
            padding: '0.75rem',
            borderRadius: '4px',
            marginBottom: '1rem',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem' }}>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1rem',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ display: 'flex', gap: '1rem' }}>
            <button
              type="button"
              onClick={onBack}
              style={{
                flex: 1,
                padding: '0.75rem',
                backgroundColor: '#f5f5f5',
                color: '#333',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1rem',
                cursor: 'pointer'
              }}
            >
              Anuluj
            </button>

            <button
              type="submit"
              disabled={loading}
              style={{
                flex: 1,
                padding: '0.75rem',
                backgroundColor: loading ? '#ccc' : '#000000',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '1rem',
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'Wysyłanie...' : 'Resetuj hasło'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}